// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deposit_wrap .deposit_price_wrap {
  margin-top: 30px;
}
.deposit_wrap .deposit_price_wrap .deposit_price_title {
  display: flex;
  align-items: center;
}
.deposit_wrap .deposit_price_wrap .deposit_price_title p {
  margin-bottom: 0px;
  margin-right: 6px;
  color: var(--light-color);
  font-weight: 500;
  font-size: 16px;
}
.deposit_wrap .deposit_price_wrap .deposit_price_title h5 {
  margin-bottom: 0px;
  font-size: 14px;
  background-color: var(--button-color);
  color: var(--light-color);
  padding: 10px 15px;
  border-radius: 25px;
  font-weight: 400;
}
.deposit_wrap .deposit_price_wrap .deposit_price_title h5 svg {
  color: #616ed6;
  font-size: 18px;
}
.deposit_wrap .deposit_price_wrap .deposit_price_title h5 img {
  margin-right: 5px;
  width: 12px;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap {
  margin-top: 20px;
  position: relative;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .form-control {
  font-size: 20px;
  border-radius: 8px 0px 0px 8px;
  border: 1px solid var(--secondary-color);
  height: 56px;
  min-width: 100px;
  background-color: var(--secondary-color);
  color: var(--light-color);
  font-weight: 600;
  width: 100%;
  padding: 10px 50px;
  border: 1px solid #FBCBA7;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .form-control:focus {
  box-shadow: none;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .input_icn {
  position: absolute;
  left: 20px;
  top: 50%;
  color: #444971;
  transform: translate(-50%, -53%);
  border-radius: 20px;
  font-weight: 500;
  padding: 0px 6px 0px;
  font-size: 28px;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .input_icn img {
  width: 15px;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .input_title {
  position: absolute;
  right: 0px;
  top: 50%;
  color: var(--dark-color);
  transform: translate(-50%, -50%);
  background: var(--primary-color);
  border-radius: 20px;
  font-weight: 500;
  padding: 2px 6px 0px;
  font-size: 11px;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap p {
  font-weight: 600;
  margin-bottom: 0px;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .deposit_inner_input {
  display: flex;
  align-items: center;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .deposit_inner_input .select_wrap {
  color: var(--light-color);
  border: 1px solid #FBCBA7;
  padding: 15px 10px;
  border-radius: 0px 8px 8px 0px;
  width: 100px;
  background: var(--secondary-color);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) var(--secondary-color) no-repeat center right 10px;
  background-size: 10px;
}
.deposit_wrap .deposit_price_wrap .deposit_input_wrap .deposit_inner_input .select_wrap:focus {
  box-shadow: none;
}
.deposit_wrap .deposit_price_wrap .wallet_bal {
  color: var(--text-color);
  font-size: 12px;
  font-weight: 600;
}
.deposit_wrap .deposit_details_wrap {
  margin-top: 30px;
}
.deposit_wrap .deposit_details_wrap .deposit_details {
  display: flex;
  align-items: center;
}
.deposit_wrap .deposit_details_wrap .deposit_details p {
  margin-bottom: 0px;
  margin-right: 6px;
  color: var(--light-color);
  font-weight: 500;
  font-size: 16px;
}
.deposit_wrap .deposit_details_wrap .deposit_details h5 {
  margin-bottom: 0px;
  font-size: 14px;
  background-color: var(--button-color);
  color: var(--light-color);
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 400;
}
.deposit_wrap .deposit_details_wrap .deposit_details h5 svg {
  color: #616ed6;
  font-size: 18px;
}
.deposit_wrap .deposit_details_wrap .deposit_details h5 img {
  margin-right: 5px;
  width: 12px;
}
.deposit_wrap .deposit_details_wrap .deposit_inner_details {
  background-color: var(--secondary-color);
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.deposit_wrap .deposit_details_wrap .deposit_inner_details img {
  width: 15px;
  margin-right: 20px;
}
.deposit_wrap .deposit_details_wrap .deposit_inner_details p {
  margin: 0px;
  color: var(--text-color);
  font-weight: 500;
  font-size: 16px;
}
.deposit_wrap .deposit_details_wrap .deposit_inner_details .input_icn {
  margin-right: 10px;
}
.deposit_wrap .deposit_btn_wrap {
  margin-top: 10px;
}
.deposit_wrap .deposit_btn_wrap .deposit_btn {
  background-color: var(--button-color);
  color: var(--light-color);
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  padding: 15px;
}
.deposit_wrap .deposit_btn_wrap .deposit_btn img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.deposit_wrap .deposit_btn_wrap .deposit_btn svg {
  font-size: 20px;
  margin-right: 5px;
}
.deposit_wrap .deposit_btn_wrap .deposit_btn:hover {
  opacity: 0.9;
}
.deposit_wrap .deposit_btn_wrap .deposit_btn:focus {
  border-color: var(--button-color);
  opacity: 0.9;
  background-color: var(--button-color);
  color: var(--light-color);
}
.deposit_wrap .transaction_hash a {
  font-size: 10px;
  text-align: center;
  word-wrap: break-word;
  background: var(--secondary-color);
  padding: 10px 0px;
  border-radius: 10px;
  display: block;
  margin-top: 5px;
  text-decoration: none;
}
.deposit_wrap .transaction_hash a:first-child {
  margin-top: 15px;
}
.deposit_wrap .transaction_hash a svg {
  font-size: 18px;
}

@media screen and (max-width: 400px) {
  .deposit_wrap .deposit_price_wrap .deposit_input_wrap .deposit_inner_input .select_wrap {
    padding: 15px 30px 15px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/deposit.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAEQ;EACI,aAAA;EACA,mBAAA;AAAZ;AAEY;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAAhB;AAGY;EACI,kBAAA;EACA,eAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AADhB;AAGgB;EACI,cAAA;EACA,eAAA;AADpB;AAIgB;EACI,iBAAA;EACA,WAAA;AAFpB;AAOQ;EACI,gBAAA;EACA,kBAAA;AALZ;AAOY;EACI,eAAA;EACA,8BAAA;EACA,wCAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AALhB;AAOgB;EACI,gBAAA;AALpB;AASY;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAPhB;AASgB;EACI,WAAA;AAPpB;AAWY;EAEI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,wBAAA;EACA,gCAAA;EACA,gCAAA;EAEA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAXhB;AAeY;EACI,gBAAA;EACA,kBAAA;AAbhB;AAgBY;EACI,aAAA;EACA,mBAAA;AAdhB;AAgBgB;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,kCAAA;EACA,sGAAA;EACA,qBAAA;AAdpB;AAiBoB;EACI,gBAAA;AAfxB;AAsBQ;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;AApBZ;AAwBI;EACI,gBAAA;AAtBR;AAwBQ;EACI,aAAA;EACA,mBAAA;AAtBZ;AAwBY;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,eAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAvBhB;AAyBgB;EACI,cAAA;EACA,eAAA;AAvBpB;AA0BgB;EACI,iBAAA;EACA,WAAA;AAxBpB;AA6BQ;EACI,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AA3BZ;AA6BY;EACI,WAAA;EACA,kBAAA;AA3BhB;AA8BY;EACI,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AA5BhB;AA+BY;EACI,kBAAA;AA7BhB;AAkCI;EACI,gBAAA;AAhCR;AAkCQ;EACI,qCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AAhCZ;AAkCY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAhChB;AAmCY;EACI,eAAA;EACA,iBAAA;AAjChB;AAoCY;EACI,YAAA;AAlChB;AAqCY;EACI,iCAAA;EACA,YAAA;EACA,qCAAA;EACA,yBAAA;AAnChB;AA0CQ;EACI,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAxCZ;AA0CY;EACI,gBAAA;AAxChB;AA2CY;EACI,eAAA;AAzChB;;AA+CA;EACI;IACI,4BAAA;EA5CN;AACF","sourcesContent":[".deposit_wrap {\r\n    .deposit_price_wrap {\r\n        margin-top: 30px;\r\n\r\n        .deposit_price_title {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            p {\r\n                margin-bottom: 0px;\r\n                margin-right: 6px;\r\n                color: var(--light-color);\r\n                font-weight: 500;\r\n                font-size: 16px;\r\n            }\r\n\r\n            h5 {\r\n                margin-bottom: 0px;\r\n                font-size: 14px;\r\n                background-color: var(--button-color);\r\n                color: var(--light-color);\r\n                padding: 10px 15px;\r\n                border-radius: 25px;\r\n                font-weight: 400;\r\n\r\n                svg {\r\n                    color: #616ed6;\r\n                    font-size: 18px;\r\n                }\r\n\r\n                img {\r\n                    margin-right: 5px;\r\n                    width: 12px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .deposit_input_wrap {\r\n            margin-top: 20px;\r\n            position: relative;\r\n\r\n            .form-control {\r\n                font-size: 20px;\r\n                border-radius: 8px 0px 0px 8px;\r\n                border: 1px solid var(--secondary-color);\r\n                height: 56px;\r\n                min-width: 100px;\r\n                background-color: var(--secondary-color);\r\n                color: var(--light-color);\r\n                font-weight: 600;\r\n                width: 100%;\r\n                padding: 10px 50px;\r\n                border: 1px solid #FBCBA7;\r\n\r\n                &:focus {\r\n                    box-shadow: none;\r\n                }\r\n            }\r\n\r\n            .input_icn {\r\n                position: absolute;\r\n                left: 20px;\r\n                top: 50%;\r\n                color: #444971;\r\n                transform: translate(-50%, -53%);\r\n                border-radius: 20px;\r\n                font-weight: 500;\r\n                padding: 0px 6px 0px;\r\n                font-size: 28px;\r\n\r\n                img {\r\n                    width: 15px;\r\n                }\r\n            }\r\n\r\n            .input_title {\r\n\r\n                position: absolute;\r\n                right: 0px;\r\n                top: 50%;\r\n                color: var(--dark-color);\r\n                transform: translate(-50%, -50%);\r\n                background: var(--primary-color);\r\n                // padding: 2px 10px 0px;\r\n                border-radius: 20px;\r\n                font-weight: 500;\r\n                padding: 2px 6px 0px;\r\n                font-size: 11px;\r\n\r\n            }\r\n\r\n            p {\r\n                font-weight: 600;\r\n                margin-bottom: 0px;\r\n            }\r\n\r\n            .deposit_inner_input {\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                .select_wrap {\r\n                    color: var(--light-color);\r\n                    border: 1px solid #FBCBA7;\r\n                    padding: 15px 10px;\r\n                    border-radius: 0px 8px 8px 0px;\r\n                    width: 100px;\r\n                    background: var(--secondary-color);\r\n                    background: url(\"../images/down.svg\") var(--secondary-color) no-repeat center right 10px;\r\n                    background-size: 10px;\r\n\r\n                    // background-position: center right 10px;\r\n                    &:focus {\r\n                        box-shadow: none;\r\n                    }\r\n                }\r\n\r\n            }\r\n        }\r\n\r\n        .wallet_bal {\r\n            color: var(--text-color);\r\n            font-size: 12px;\r\n            font-weight: 600;\r\n        }\r\n    }\r\n\r\n    .deposit_details_wrap {\r\n        margin-top: 30px;\r\n\r\n        .deposit_details {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            p {\r\n                margin-bottom: 0px;\r\n                margin-right: 6px;\r\n                color: var(--light-color);\r\n                font-weight: 500;\r\n                font-size: 16px;\r\n            }\r\n\r\n            h5 {\r\n                margin-bottom: 0px;\r\n                font-size: 14px;\r\n                background-color: var(--button-color);\r\n                color: var(--light-color);\r\n                padding: 10px 20px;\r\n                border-radius: 25px;\r\n                font-weight: 400;\r\n\r\n                svg {\r\n                    color: #616ed6;\r\n                    font-size: 18px;\r\n                }\r\n\r\n                img {\r\n                    margin-right: 5px;\r\n                    width: 12px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .deposit_inner_details {\r\n            background-color: var(--secondary-color);\r\n            padding: 15px;\r\n            border-radius: 8px;\r\n            margin-top: 20px;\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            img {\r\n                width: 15px;\r\n                margin-right: 20px;\r\n            }\r\n\r\n            p {\r\n                margin: 0px;\r\n                color: var(--text-color);\r\n                font-weight: 500;\r\n                font-size: 16px;\r\n            }\r\n\r\n            .input_icn {\r\n                margin-right: 10px\r\n            }\r\n        }\r\n    }\r\n\r\n    .deposit_btn_wrap {\r\n        margin-top: 10px;\r\n\r\n        .deposit_btn {\r\n            background-color: var(--button-color);\r\n            color: var(--light-color);\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n            width: 100%;\r\n            padding: 15px;\r\n\r\n            img {\r\n                width: 20px;\r\n                height: 20px;\r\n                margin-right: 5px;\r\n            }\r\n\r\n            svg {\r\n                font-size: 20px;\r\n                margin-right: 5px;\r\n            }\r\n\r\n            &:hover {\r\n                opacity: 0.9;\r\n            }\r\n\r\n            &:focus {\r\n                border-color: var(--button-color);\r\n                opacity: 0.9;\r\n                background-color: var(--button-color);\r\n                color: var(--light-color);\r\n            }\r\n        }\r\n    }\r\n\r\n    .transaction_hash {\r\n\r\n        a {\r\n            font-size: 10px;\r\n            text-align: center;\r\n            word-wrap: break-word;\r\n            background: var(--secondary-color);\r\n            padding: 10px 0px;\r\n            border-radius: 10px;\r\n            display: block;\r\n            margin-top: 5px;\r\n            text-decoration: none;\r\n\r\n            &:first-child {\r\n                margin-top: 15px;\r\n            }\r\n\r\n            svg {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n@media screen and (max-width:400px) {\r\n    .deposit_wrap .deposit_price_wrap .deposit_input_wrap .deposit_inner_input .select_wrap{\r\n        padding: 15px 30px 15px 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
